// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.maine-banner {
    padding-top: 0px;
  }
  
  .maint-abt-inner img {
    width: 100%;
  }

  p{
    font-family: "Poppins";
    font-style: normal;
    font-weight: 400;
    font-size: 12px;
    line-height: 24px;
  }
  
  .maint-abt-inner h3 {
    font-family: "Poppins";
    font-style: normal;
    font-weight: 500;
    font-size: 40px;
    line-height: 52px;
    text-align: left;
    padding-right: 40px;
    position: absolute;
    left: 100px;
    bottom: 130px;
    color: #fff;
  }
  
  .maint-abt-inner {
    position: relative;
  }
  
  .main-vision {
    background-color: #000;
    padding-top: 50px;
    padding-bottom: 30px;
  }
  
  .new-team h3 {
    font-family: "Poppins";
    font-style: normal;
    font-weight: 500;
    font-size: 40px;
    line-height: 50px;
    color: #202020;
    text-align: center;
    padding: 0px 305px;
    margin-bottom: 55px;
  }
  
  .new-team {
    background-color: #f1f1f1;
    padding: 60px 0px;
  }
  
  .new-team-inner-right h4 {
    font-family: "Poppins";
    font-style: normal;
    font-weight: 700;
    font-size: 18px;
    line-height: 18px;
    color: #55b56d;
    margin-bottom: 8px;
    margin-top: 3px;
  }
  
  .new-team-inner-right h5 {
    font-family: "Poppins";
    font-style: normal;
    font-weight: 500;
    font-size: 16px;
    line-height: 18px;
    color: #202020;
    margin-bottom: 4px;
  }
  
  .new-team-inner-left {
    width: 33%;
    margin-right: 20px;
  }
  
  .new-team-inner-right {
    width: 67%;
  }
  
  .new-team-inner-left img {
    width: 100%;
    background-color: #fff;
    padding: 4px;
    box-shadow: rgba(0, 0, 0, 0.24) 0px 3px 8px;
  }
  
  .new-team-inner {
    margin-bottom: 35px;
  }
  
  .new-team-inner-right p {
    text-align: justify;
  }

  .ctmABMWth{
    width: 33%;
    text-align: center;
    padding-bottom: 30px;
  }

  .ctmABMWth h5{font-size: 1.2rem; text-align: center; color: #252525;}
  
  .counter img {
    background-color: #55b56d;
    padding: 8px;
    width: 15%;
    margin-bottom: 5px;
  }
  
  .maine-banner-left p {
    padding-top: 30px;
    font-size: 20px;
    line-height: 28px;
  }
  .abt-st {
    background-color: #fff;
  }
  .abt-st h2 {
    font-size: 50px;
    line-height: 58px;
  }
  
  .our-team {
    background-color: #f5f5f5;
    padding: 60px 0px;
  }
  
  .our-team h3 {
    font-family: "Poppins";
    font-style: normal;
    font-weight: 500;
    font-size: 40px;
    line-height: 48px;
    width: 28%;
    margin-bottom: 25px;
  }
  
  .our-team-bx h6 {
    font-family: "Poppins";
    font-style: normal;
    font-weight: 400;
    font-size: 20px;
    line-height: 30px;
    margin-bottom: 2px;
    color: #565656;
  }
  
  .our-team-bx h5 {
    font-family: "Poppins";
    font-style: normal;
    font-weight: 500;
    font-size: 20px;
    line-height: 30px;
    color: #565656;
    margin-bottom: 0px;
  }
  
  .our-team .row {
    border-bottom: 1px solid #55b56d;
    border-top: 1px solid #55b56d;
    padding: 30px 0px;
    padding-bottom: 5px;
  }
  
  .our-team-bx {
    box-shadow: rgba(0, 0, 0, 0.1) 0px 4px 12px;
    background-color: #fff;
    padding: 6px;
    margin-bottom: 25px;
  }
  
  .join-left h3 {
    width: 384px;
  }`, "",{"version":3,"sources":["webpack://./src/pages/AbmServices/AbmServices.css"],"names":[],"mappings":"AAAA;IACI,gBAAgB;EAClB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,sBAAsB;IACtB,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,iBAAiB;EACnB;;EAEA;IACE,sBAAsB;IACtB,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,gBAAgB;IAChB,mBAAmB;IACnB,kBAAkB;IAClB,WAAW;IACX,aAAa;IACb,WAAW;EACb;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,sBAAsB;IACtB,iBAAiB;IACjB,oBAAoB;EACtB;;EAEA;IACE,sBAAsB;IACtB,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,cAAc;IACd,kBAAkB;IAClB,kBAAkB;IAClB,mBAAmB;EACrB;;EAEA;IACE,yBAAyB;IACzB,iBAAiB;EACnB;;EAEA;IACE,sBAAsB;IACtB,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,cAAc;IACd,kBAAkB;IAClB,eAAe;EACjB;;EAEA;IACE,sBAAsB;IACtB,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,cAAc;IACd,kBAAkB;EACpB;;EAEA;IACE,UAAU;IACV,kBAAkB;EACpB;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,WAAW;IACX,sBAAsB;IACtB,YAAY;IACZ,2CAA2C;EAC7C;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,UAAU;IACV,kBAAkB;IAClB,oBAAoB;EACtB;;EAEA,cAAc,iBAAiB,EAAE,kBAAkB,EAAE,cAAc,CAAC;;EAEpE;IACE,yBAAyB;IACzB,YAAY;IACZ,UAAU;IACV,kBAAkB;EACpB;;EAEA;IACE,iBAAiB;IACjB,eAAe;IACf,iBAAiB;EACnB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,eAAe;IACf,iBAAiB;EACnB;;EAEA;IACE,yBAAyB;IACzB,iBAAiB;EACnB;;EAEA;IACE,sBAAsB;IACtB,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,UAAU;IACV,mBAAmB;EACrB;;EAEA;IACE,sBAAsB;IACtB,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,kBAAkB;IAClB,cAAc;EAChB;;EAEA;IACE,sBAAsB;IACtB,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,cAAc;IACd,kBAAkB;EACpB;;EAEA;IACE,gCAAgC;IAChC,6BAA6B;IAC7B,iBAAiB;IACjB,mBAAmB;EACrB;;EAEA;IACE,2CAA2C;IAC3C,sBAAsB;IACtB,YAAY;IACZ,mBAAmB;EACrB;;EAEA;IACE,YAAY;EACd","sourcesContent":[".maine-banner {\r\n    padding-top: 0px;\r\n  }\r\n  \r\n  .maint-abt-inner img {\r\n    width: 100%;\r\n  }\r\n\r\n  p{\r\n    font-family: \"Poppins\";\r\n    font-style: normal;\r\n    font-weight: 400;\r\n    font-size: 12px;\r\n    line-height: 24px;\r\n  }\r\n  \r\n  .maint-abt-inner h3 {\r\n    font-family: \"Poppins\";\r\n    font-style: normal;\r\n    font-weight: 500;\r\n    font-size: 40px;\r\n    line-height: 52px;\r\n    text-align: left;\r\n    padding-right: 40px;\r\n    position: absolute;\r\n    left: 100px;\r\n    bottom: 130px;\r\n    color: #fff;\r\n  }\r\n  \r\n  .maint-abt-inner {\r\n    position: relative;\r\n  }\r\n  \r\n  .main-vision {\r\n    background-color: #000;\r\n    padding-top: 50px;\r\n    padding-bottom: 30px;\r\n  }\r\n  \r\n  .new-team h3 {\r\n    font-family: \"Poppins\";\r\n    font-style: normal;\r\n    font-weight: 500;\r\n    font-size: 40px;\r\n    line-height: 50px;\r\n    color: #202020;\r\n    text-align: center;\r\n    padding: 0px 305px;\r\n    margin-bottom: 55px;\r\n  }\r\n  \r\n  .new-team {\r\n    background-color: #f1f1f1;\r\n    padding: 60px 0px;\r\n  }\r\n  \r\n  .new-team-inner-right h4 {\r\n    font-family: \"Poppins\";\r\n    font-style: normal;\r\n    font-weight: 700;\r\n    font-size: 18px;\r\n    line-height: 18px;\r\n    color: #55b56d;\r\n    margin-bottom: 8px;\r\n    margin-top: 3px;\r\n  }\r\n  \r\n  .new-team-inner-right h5 {\r\n    font-family: \"Poppins\";\r\n    font-style: normal;\r\n    font-weight: 500;\r\n    font-size: 16px;\r\n    line-height: 18px;\r\n    color: #202020;\r\n    margin-bottom: 4px;\r\n  }\r\n  \r\n  .new-team-inner-left {\r\n    width: 33%;\r\n    margin-right: 20px;\r\n  }\r\n  \r\n  .new-team-inner-right {\r\n    width: 67%;\r\n  }\r\n  \r\n  .new-team-inner-left img {\r\n    width: 100%;\r\n    background-color: #fff;\r\n    padding: 4px;\r\n    box-shadow: rgba(0, 0, 0, 0.24) 0px 3px 8px;\r\n  }\r\n  \r\n  .new-team-inner {\r\n    margin-bottom: 35px;\r\n  }\r\n  \r\n  .new-team-inner-right p {\r\n    text-align: justify;\r\n  }\r\n\r\n  .ctmABMWth{\r\n    width: 33%;\r\n    text-align: center;\r\n    padding-bottom: 30px;\r\n  }\r\n\r\n  .ctmABMWth h5{font-size: 1.2rem; text-align: center; color: #252525;}\r\n  \r\n  .counter img {\r\n    background-color: #55b56d;\r\n    padding: 8px;\r\n    width: 15%;\r\n    margin-bottom: 5px;\r\n  }\r\n  \r\n  .maine-banner-left p {\r\n    padding-top: 30px;\r\n    font-size: 20px;\r\n    line-height: 28px;\r\n  }\r\n  .abt-st {\r\n    background-color: #fff;\r\n  }\r\n  .abt-st h2 {\r\n    font-size: 50px;\r\n    line-height: 58px;\r\n  }\r\n  \r\n  .our-team {\r\n    background-color: #f5f5f5;\r\n    padding: 60px 0px;\r\n  }\r\n  \r\n  .our-team h3 {\r\n    font-family: \"Poppins\";\r\n    font-style: normal;\r\n    font-weight: 500;\r\n    font-size: 40px;\r\n    line-height: 48px;\r\n    width: 28%;\r\n    margin-bottom: 25px;\r\n  }\r\n  \r\n  .our-team-bx h6 {\r\n    font-family: \"Poppins\";\r\n    font-style: normal;\r\n    font-weight: 400;\r\n    font-size: 20px;\r\n    line-height: 30px;\r\n    margin-bottom: 2px;\r\n    color: #565656;\r\n  }\r\n  \r\n  .our-team-bx h5 {\r\n    font-family: \"Poppins\";\r\n    font-style: normal;\r\n    font-weight: 500;\r\n    font-size: 20px;\r\n    line-height: 30px;\r\n    color: #565656;\r\n    margin-bottom: 0px;\r\n  }\r\n  \r\n  .our-team .row {\r\n    border-bottom: 1px solid #55b56d;\r\n    border-top: 1px solid #55b56d;\r\n    padding: 30px 0px;\r\n    padding-bottom: 5px;\r\n  }\r\n  \r\n  .our-team-bx {\r\n    box-shadow: rgba(0, 0, 0, 0.1) 0px 4px 12px;\r\n    background-color: #fff;\r\n    padding: 6px;\r\n    margin-bottom: 25px;\r\n  }\r\n  \r\n  .join-left h3 {\r\n    width: 384px;\r\n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
